import { all, call } from 'redux-saga/effects';
import { checkAuthState } from 'app/pages/AuthPage/slice/saga';

export default function* rootSaga() {
  yield all([call(checkAuthState)]);
}
